// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminSchoolStudentsPanel {
  border: 1px solid #dde3ea;
  box-shadow: 0 2px 8px rgba(20, 33, 61, 0.06);
}

.SuperAdminSchoolStudentsFlags label {
  margin-bottom: 0.6rem;
}

.SuperAdminSchoolStudentsDetailRow {
  display: flex;
  border-bottom: 1px solid #eef1f5;
  padding: 6px 0;
}

.SuperAdminSchoolStudentsDetailLabel {
  color: #6c757d;
  flex: 0 0 155px;
  font-weight: 600;
}

.SuperAdminSchoolStudentsDetailValue {
  flex: 1;
  word-break: break-word;
}

.SuperAdminSchoolStudentsTextBox {
  background: #f8f9fa;
  border: 1px solid #e6e9ee;
  border-radius: 4px;
  min-height: 42px;
  padding: 10px;
  white-space: pre-wrap;
}

.SuperAdminSchoolStudentsKinList {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 10px;
}

.SuperAdminSchoolStudentsKinCard {
  background: #f8f9fa;
  border: 1px solid #e6e9ee;
  border-radius: 4px;
  padding: 10px;
}

.SuperAdminSchoolStudentsJson {
  background: #20242a;
  border-radius: 4px;
  color: #f8f9fa;
  max-height: 420px;
  overflow: auto;
  padding: 12px;
}

.SuperAdminSchoolStudentsNextOfKinForm {
  border-top: 1px solid #eef1f5;
  margin-bottom: 1rem;
  padding-top: 1rem;
}

.SuperAdminSchoolStudentsNextOfKinFormCard {
  background: #fbfcfd;
  border: 1px solid #e6e9ee;
  border-radius: 4px;
  margin-bottom: 10px;
  padding: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/School/Students/SuperAdminSchoolStudents.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf","sourcesContent":[".SuperAdminSchoolStudentsPanel {\n  border: 1px solid #dde3ea;\n  box-shadow: 0 2px 8px rgba(20, 33, 61, 0.06);\n}\n\n.SuperAdminSchoolStudentsFlags label {\n  margin-bottom: 0.6rem;\n}\n\n.SuperAdminSchoolStudentsDetailRow {\n  display: flex;\n  border-bottom: 1px solid #eef1f5;\n  padding: 6px 0;\n}\n\n.SuperAdminSchoolStudentsDetailLabel {\n  color: #6c757d;\n  flex: 0 0 155px;\n  font-weight: 600;\n}\n\n.SuperAdminSchoolStudentsDetailValue {\n  flex: 1;\n  word-break: break-word;\n}\n\n.SuperAdminSchoolStudentsTextBox {\n  background: #f8f9fa;\n  border: 1px solid #e6e9ee;\n  border-radius: 4px;\n  min-height: 42px;\n  padding: 10px;\n  white-space: pre-wrap;\n}\n\n.SuperAdminSchoolStudentsKinList {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 10px;\n}\n\n.SuperAdminSchoolStudentsKinCard {\n  background: #f8f9fa;\n  border: 1px solid #e6e9ee;\n  border-radius: 4px;\n  padding: 10px;\n}\n\n.SuperAdminSchoolStudentsJson {\n  background: #20242a;\n  border-radius: 4px;\n  color: #f8f9fa;\n  max-height: 420px;\n  overflow: auto;\n  padding: 12px;\n}\n\n.SuperAdminSchoolStudentsNextOfKinForm {\n  border-top: 1px solid #eef1f5;\n  margin-bottom: 1rem;\n  padding-top: 1rem;\n}\n\n.SuperAdminSchoolStudentsNextOfKinFormCard {\n  background: #fbfcfd;\n  border: 1px solid #e6e9ee;\n  border-radius: 4px;\n  margin-bottom: 10px;\n  padding: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
